import { useState } from "react";
import "../styles.css";

const labels = [
  "About",
  "Courses",
  "Curriculum",
  "Success",
  "Gallery",
  "Blog",
  "Contact",
];

function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="container-x navbar-inner">
        <div className="navbar-brand">
          <img
             src="/logo.png"
             alt="Smart Mobile Training Logo"
             className="navbar-logo"
          />
        </div>

        <div className="navbar-desktop-menu">
          {labels.map((label) => (
            <span key={label} className="navbar-label">
              {label}
            </span>
          ))}
        </div>

        <div className="navbar-actions">
          <span className="navbar-cta bg-primary">Apply Now</span>

          <button
            type="button"
            aria-label="Menu"
            aria-expanded={open}
            onClick={() => setOpen(!open)}
            className="navbar-menu-btn"
          >
            <span className="navbar-menu-icon" />
          </button>
        </div>
      </div>

      {open && (
        <div className="navbar-mobile-menu">
          <div className="container-x navbar-mobile-inner">
            {labels.map((label) => (
              <span key={label} className="navbar-mobile-label">
                {label}
              </span> 
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
 